const startLiveBroadcast = resolve => require(['@/pages/liveBroadcast/startLiveBroadcast/index.vue'], resolve)
const myLiveBroadcast = resolve => require(['@/pages/liveBroadcast/myLiveBroadcast/index.vue'], resolve)
const liveBroadcastInfo = resolve => require(['@/pages/liveBroadcast/liveBroadcastInfo/index.vue'], resolve)
const viewDetails = resolve => require(['@/pages/liveBroadcast/myLiveBroadcast/viewDetails.vue'], resolve)
const addNotice = resolve => require(['@/pages/liveBroadcast/liveBroadcastInfo/addNotice.vue'], resolve)
const checkNotice = resolve => require(['@/pages/liveBroadcast/liveBroadcastInfo/checkNotice.vue'], resolve)
const liveConsole = resolve => require(['@/pages/liveBroadcast/startLiveBroadcast/liveConsole/consoleIndex.vue'], resolve)
export default[
    //发起直播
    {
      path: "/startLiveBroadcast",
      name: "发起直播",
      component: startLiveBroadcast
    },
    {
      path: "/myLiveBroadcast/liveConsole",
      name: "发起直播进入控制台",
      component: liveConsole
    },
    {
      path: "/myLiveBroadcast",
      name: "我的直播",
      component: myLiveBroadcast
    },
    {
      path: "/myLiveBroadcast/viewDetails",
      name: "我的直播查看详情",
      component: viewDetails
    },
    {
      path: "/liveBroadcastInfo",
      name: "直播间信息管理",
        component: liveBroadcastInfo
    },
    {
      path: "/liveBroadcastInfo/publishNotice",
      name: "直播间信息管理发布公告",
      component: addNotice
    },
    {
      path: "/liveBroadcastInfo/checkNotice",
      name: "直播间管理查看公告",
      component: checkNotice
    },
    
]